var _style, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _g4, _path13, _path14, _path15, _g5, _path16, _path17, _path18, _g6, _path19, _path20, _path21, _g7, _path22, _path23, _path24, _g8, _path25, _path26, _path27, _g9, _path28, _path29, _path30, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 108.7 67.9",
    style: {
      enableBackground: "new 0 0 108.7 67.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ECF1FF;}\r\n\t.st1{opacity:0.3;fill:#DDF3EE;enable-background:new    ;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{fill:#9BA9B7;}\r\n\t.st4{fill:url(#SVGID_2_);}\r\n\t.st5{fill:url(#SVGID_3_);}\r\n\t.st6{fill:url(#SVGID_4_);}\r\n\t.st7{fill:url(#SVGID_5_);}\r\n\t.st8{fill:url(#SVGID_6_);}\r\n\t.st9{fill:url(#SVGID_7_);}\r\n\t.st10{fill:url(#SVGID_8_);}\r\n\t.st11{fill:url(#SVGID_9_);}\r\n\t.st12{fill:url(#SVGID_10_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.9,58.5L2.9,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C0.1,1.2,1.4,0,2.9,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C5.7,57.3,4.4,58.5,2.9,58.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.9,58.5L2.9,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C0.1,1.2,1.4,0,2.9,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C5.7,57.3,4.4,58.5,2.9,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.9,
    y1: 11.4588,
    x2: 2.9,
    y2: 51.1588,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2.9,58.5L2.9,58.5c-1.6,0-2.8-1.3-2.8-2.8V21.6c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v34.1 C5.7,57.3,4.4,58.5,2.9,58.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.3,67.7H0.9v-2.5c0-0.2,0-0.4,0-0.6l-0.1,0.1c0,0-0.2,0.2-0.6,0.5L0,64.9l0.9-0.7h0.3L1.3,67.7L1.3,67.7 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M5.1,65.9c0,0.6-0.1,1.1-0.3,1.4s-0.5,0.5-0.9,0.5S3.2,67.6,3,67.3s-0.3-0.8-0.3-1.4s0.1-1.1,0.3-1.4 S3.5,64,3.9,64s0.7,0.2,0.9,0.5C5,64.9,5.1,65.3,5.1,65.9z M3.1,65.9c0,0.5,0.1,0.9,0.2,1.1c0.1,0.2,0.3,0.4,0.6,0.4 s0.5-0.1,0.6-0.4c0.1-0.2,0.2-0.6,0.2-1.1S4.6,65,4.5,64.8c-0.1-0.2-0.3-0.4-0.6-0.4s-0.5,0.1-0.6,0.4S3.1,65.4,3.1,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.2,58.5L14.2,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0C15.8,0,17,1.3,17,2.8v52.9 C17,57.3,15.7,58.5,14.2,58.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14.2,58.5L14.2,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0C15.8,0,17,1.3,17,2.8v52.9 C17,57.3,15.7,58.5,14.2,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.2,
    y1: -11.0358,
    x2: 14.2,
    y2: 63.8767,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M14.2,58.5L14.2,58.5c-1.6,0-2.8-1.3-2.8-2.8V10.9c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v44.8 C17,57.3,15.7,58.5,14.2,58.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M12.7,67.7h-2.3v-0.3l0.9-0.9c0.3-0.3,0.5-0.5,0.6-0.6s0.2-0.2,0.2-0.4s0.1-0.2,0.1-0.4 c0-0.2-0.1-0.3-0.2-0.5s-0.3-0.2-0.5-0.2c-0.1,0-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.4,0.3l-0.3-0.3c0.3-0.3,0.7-0.4,1.1-0.4 c0.3,0,0.6,0.1,0.8,0.3s0.3,0.4,0.3,0.7c0,0.2-0.1,0.5-0.2,0.7s-0.4,0.5-0.7,0.8l-0.8,0.8l0,0h1.8 C12.7,67.4,12.7,67.7,12.7,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M15.5,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5s-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4s0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5C15.4,64.9,15.5,65.3,15.5,65.9z M13.6,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4c0.1-0.2,0.2-0.6,0.2-1.1S15.1,65,15,64.8s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 S13.6,65.4,13.6,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,58.5L25.4,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C28.2,57.3,27,58.5,25.4,58.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M25.4,58.5L25.4,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C28.2,57.3,27,58.5,25.4,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 25.4,
    y1: 3.4634,
    x2: 25.4,
    y2: 35.1468,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25.4,58.5L25.4,58.5c-1.6,0-2.8-1.3-2.8-2.8v-26c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v26 C28.2,57.3,27,58.5,25.4,58.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M23.8,65c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.3l0,0c0.3,0,0.5,0.1,0.6,0.3s0.2,0.3,0.2,0.6 c0,0.3-0.1,0.6-0.4,0.8c-0.2,0.2-0.6,0.3-1,0.3c-0.2,0-0.4,0-0.5,0c-0.2,0-0.3-0.1-0.5-0.2v-0.4c0.2,0.1,0.3,0.1,0.5,0.2 c0.2,0,0.3,0.1,0.5,0.1c0.6,0,0.9-0.2,0.9-0.7c0-0.4-0.3-0.6-1-0.6H22V66h0.4c0.3,0,0.5-0.1,0.7-0.2s0.3-0.6,0.3-0.8 s-0.1-0.3-0.2-0.4s-0.3-0.1-0.5-0.1s-0.3,0-0.4,0.1c-0.1,0-0.3,0.1-0.5,0.2l-0.2-0.3c0.1-0.1,0.3-0.2,0.5-0.3 c0.2-0.1,0.4-0.1,0.6-0.1c0.3,0,0.6,0.1,0.8,0.2C23.7,64.5,23.8,64.7,23.8,65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M26.8,65.9c0,0.6-0.1,1.1-0.3,1.4s-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5s-0.3-0.8-0.3-1.4s0.1-1.1,0.3-1.4 s0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5C26.7,64.9,26.8,65.3,26.8,65.9z M24.9,65.9c0,0.5,0.1,0.9,0.2,1.1c0.1,0.2,0.3,0.4,0.6,0.4 s0.5-0.1,0.6-0.4c0.1-0.2,0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1c-0.1-0.2-0.3-0.4-0.6-0.4s-0.5,0.1-0.6,0.4S24.9,65.4,24.9,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.7,58.5L36.7,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C39.5,57.3,38.3,58.5,36.7,58.5z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M36.7,58.5L36.7,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C39.5,57.3,38.3,58.5,36.7,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.7,
    y1: -3.6967,
    x2: 36.7,
    y2: 46.782,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M36.7,58.5L36.7,58.5c-1.6,0-2.8-1.3-2.8-2.8V10.9c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v44.8 C39.5,57.3,38.3,58.5,36.7,58.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M35.3,66.9h-0.5v0.8h-0.4v-0.8h-1.7v-0.4l1.7-2.4h0.4v2.4h0.5V66.9z M34.4,66.5v-1.2c0-0.2,0-0.5,0-0.8 l0,0c-0.1,0.2-0.2,0.3-0.2,0.4l-1.1,1.6H34.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38,65.9c0,0.6-0.1,1.1-0.3,1.4s-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5s-0.3-0.8-0.3-1.4s0.1-1.1,0.3-1.4 s0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5C37.9,64.9,38,65.3,38,65.9z M36,65.9c0,0.5,0.1,0.9,0.2,1.1c0.1,0.2,0.3,0.4,0.6,0.4 s0.5-0.1,0.6-0.4c0.1-0.2,0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1c-0.1-0.2-0.3-0.4-0.6-0.4s-0.5,0.1-0.6,0.4S36,65.4,36,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,58.5L48,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C45.2,1.2,46.5,0,48,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C50.8,57.3,49.5,58.5,48,58.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,58.5L48,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C45.2,1.2,46.5,0,48,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C50.8,57.3,49.5,58.5,48,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    y1: -2.026,
    x2: 48,
    y2: 39.8606,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M48,58.5L48,58.5c-1.6,0-2.8-1.3-2.8-2.8V19.5c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v36.2 C50.8,57.3,49.5,58.5,48,58.5z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M45.7,65.5c0.4,0,0.7,0.1,0.9,0.3c0.2,0.2,0.3,0.4,0.3,0.8s-0.1,0.7-0.4,0.9c-0.2,0.2-0.6,0.3-1,0.3 s-0.7-0.1-0.9-0.2v-0.4c0.1,0.1,0.3,0.1,0.4,0.2c0.2,0,0.3,0.1,0.5,0.1c0.3,0,0.5-0.1,0.7-0.2s0.2-0.3,0.2-0.6 c0-0.5-0.3-0.7-0.9-0.7c-0.2,0-0.4,0-0.6,0.1L44.7,66l0.1-1.7h1.8v0.4h-1.4l-0.1,1.1C45.3,65.5,45.5,65.5,45.7,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M49.8,65.9c0,0.6-0.1,1.1-0.3,1.4s-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5s-0.3-0.8-0.3-1.4s0.1-1.1,0.3-1.4 s0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5C49.7,64.9,49.8,65.3,49.8,65.9z M47.8,65.9c0,0.5,0.1,0.9,0.2,1.1c0.1,0.2,0.3,0.4,0.6,0.4 s0.5-0.1,0.6-0.4c0.1-0.2,0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1c-0.1-0.2-0.3-0.4-0.6-0.4s-0.5,0.1-0.6,0.4S47.8,65.4,47.8,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M59.2,58.5L59.2,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0C60.8,0,62,1.3,62,2.8v52.9 C62.1,57.3,60.8,58.5,59.2,58.5z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M59.2,58.5L59.2,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0C60.8,0,62,1.3,62,2.8v52.9 C62.1,57.3,60.8,58.5,59.2,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 59.2027,
    y1: 1.0767,
    x2: 59.2027,
    y2: 32.7601,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.2,58.5L59.2,58.5c-1.6,0-2.8-1.3-2.8-2.8v-26c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v26 C62.1,57.3,60.8,58.5,59.2,58.5z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M55.4,66.2c0-0.7,0.1-1.2,0.4-1.6c0.3-0.3,0.7-0.5,1.2-0.5c0.2,0,0.3,0,0.4,0v0.3c-0.1,0-0.3-0.1-0.4-0.1 c-0.4,0-0.7,0.1-0.9,0.4s-0.3,0.6-0.3,1.1l0,0c0.2-0.3,0.5-0.4,0.8-0.4c0.3,0,0.6,0.1,0.8,0.3c0.2,0.2,0.3,0.5,0.3,0.8 c0,0.4-0.1,0.7-0.3,0.9c-0.2,0.2-0.5,0.3-0.8,0.3c-0.4,0-0.7-0.1-0.9-0.4C55.5,67.1,55.4,66.7,55.4,66.2z M56.6,67.4 c0.2,0,0.4-0.1,0.5-0.2s0.2-0.4,0.2-0.6s-0.1-0.4-0.2-0.6c-0.1-0.1-0.3-0.2-0.5-0.2c-0.1,0-0.3,0-0.4,0.1 C56.1,66,56,66,55.9,66.1s-0.1,0.2-0.1,0.3c0,0.2,0,0.3,0.1,0.5s0.2,0.3,0.3,0.3C56.3,67.4,56.5,67.4,56.6,67.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.6,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S60.6,65.3,60.6,65.9z M58.6,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1S60.1,65,60,64.8s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C58.7,65,58.6,65.4,58.6,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M70.5,58.5L70.5,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C67.7,1.2,69,0,70.5,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C73.3,57.3,72.1,58.5,70.5,58.5z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.5,58.5L70.5,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C67.7,1.2,69,0,70.5,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C73.3,57.3,72.1,58.5,70.5,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 70.5,
    y1: -3.4581,
    x2: 70.5,
    y2: 49.7057,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M70.5,58.5L70.5,58.5c-1.6,0-2.8-1.3-2.8-2.8V8.2c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v47.5 C73.3,57.3,72.1,58.5,70.5,58.5z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M67.1,67.7l1.5-3.2h-1.9v-0.4h2.4v0.3l-1.5,3.2L67.1,67.7L67.1,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.8,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S71.8,65.3,71.8,65.9z M69.9,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C70,65,69.9,65.4,69.9,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.8,58.5L81.8,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C79,1.2,80.3,0,81.8,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C84.6,57.3,83.3,58.5,81.8,58.5z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81.8,58.5L81.8,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C79,1.2,80.3,0,81.8,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C84.6,57.3,83.3,58.5,81.8,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 81.8,
    y1: 4.4181,
    x2: 81.8,
    y2: 30.7181,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M81.8,58.5L81.8,58.5c-1.6,0-2.8-1.3-2.8-2.8V35c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v20.7 C84.6,57.3,83.3,58.5,81.8,58.5z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.8,64.1c0.3,0,0.6,0.1,0.8,0.2c0.2,0.2,0.3,0.4,0.3,0.6s-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.3-0.5,0.4 c0.3,0.1,0.5,0.3,0.6,0.4s0.2,0.3,0.2,0.5c0,0.3-0.1,0.5-0.3,0.7s-0.5,0.3-0.8,0.3c-0.4,0-0.7-0.1-0.9-0.2s-0.3-0.4-0.3-0.7 c0-0.4,0.2-0.7,0.7-1c-0.2-0.1-0.4-0.3-0.5-0.4s-0.1-0.3-0.1-0.5c0-0.3,0.1-0.5,0.3-0.6C78.2,64.2,78.5,64.1,78.8,64.1z  M78,66.8c0,0.2,0.1,0.3,0.2,0.5s0.3,0.2,0.6,0.2c0.2,0,0.4-0.1,0.6-0.2c0.1-0.1,0.2-0.3,0.2-0.5s-0.1-0.3-0.2-0.4 s-0.3-0.2-0.7-0.4c-0.2,0.1-0.4,0.2-0.5,0.3C78.1,66.5,78,66.6,78,66.8z M78.8,64.4c-0.2,0-0.4,0-0.5,0.1s-0.2,0.2-0.2,0.4 c0,0.1,0,0.3,0.1,0.4s0.3,0.2,0.5,0.3c0.2-0.1,0.4-0.2,0.5-0.3c0.1-0.1,0.1-0.2,0.1-0.4c0-0.2-0.1-0.3-0.2-0.4 S79,64.4,78.8,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M82.9,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S82.9,65.3,82.9,65.9z M80.9,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C81,65,80.9,65.4,80.9,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93,58.5L93,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C90.2,1.2,91.5,0,93,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C95.9,57.3,94.6,58.5,93,58.5z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M93,58.5L93,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8C90.2,1.2,91.5,0,93,0l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C95.9,57.3,94.6,58.5,93,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 93.0027,
    y1: 6.4468,
    x2: 93.0027,
    y2: 19.3349,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M93,58.5L93,58.5c-1.6,0-2.8-1.3-2.8-2.8v-7.2c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v7.2 C95.9,57.3,94.6,58.5,93,58.5z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.2,65.7c0,1.4-0.5,2.1-1.6,2.1c-0.2,0-0.3,0-0.4,0v-0.3c0.1,0,0.3,0.1,0.4,0.1c0.4,0,0.7-0.1,0.9-0.4 c0.2-0.2,0.3-0.6,0.3-1.1l0,0c-0.1,0.1-0.2,0.2-0.4,0.3c-0.1,0.1-0.3,0.1-0.5,0.1c-0.3,0-0.6-0.1-0.8-0.3 c-0.2-0.2-0.3-0.5-0.3-0.8c0-0.4,0.1-0.7,0.3-0.9c0.2-0.2,0.5-0.3,0.8-0.3c0.2,0,0.5,0.1,0.6,0.2c0.2,0.1,0.3,0.3,0.4,0.5 S91.2,65.3,91.2,65.7z M90,64.4c-0.2,0-0.4,0.1-0.5,0.2s-0.2,0.4-0.2,0.6s0.1,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.5,0.2 c0.1,0,0.3,0,0.4-0.1s0.2-0.1,0.3-0.2c0.1-0.1,0.1-0.2,0.1-0.3c0-0.2,0-0.3-0.1-0.5s-0.2-0.3-0.3-0.3 C90.3,64.5,90.1,64.4,90,64.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M94.1,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S94.1,65.3,94.1,65.9z M92.1,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C92.2,65,92.1,65.4,92.1,65.9z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.3,58.5L104.3,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C107.1,57.3,105.9,58.5,104.3,58.5z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M104.3,58.5L104.3,58.5c-1.6,0-2.8-1.3-2.8-2.8V2.8c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v52.9 C107.1,57.3,105.9,58.5,104.3,58.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 104.3,
    y1: -2.2647,
    x2: 104.3,
    y2: 29.4188,
    gradientTransform: "matrix(1 0 0 -1 0 70)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#00AEF6"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M104.3,58.5L104.3,58.5c-1.6,0-2.8-1.3-2.8-2.8v-26c0-1.6,1.3-2.8,2.8-2.8l0,0c1.6,0,2.8,1.3,2.8,2.8v26 C107.1,57.3,105.9,58.5,104.3,58.5z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M102.1,67.7h-0.4v-2.5c0-0.2,0-0.4,0-0.6l-0.1,0.1c0,0-0.2,0.2-0.6,0.5l-0.2-0.3l0.9-0.7h0.3L102.1,67.7 L102.1,67.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M105.8,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S105.8,65.3,105.8,65.9z M103.9,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C103.9,65,103.9,65.4,103.9,65.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M108.7,65.9c0,0.6-0.1,1.1-0.3,1.4c-0.2,0.3-0.5,0.5-0.9,0.5s-0.7-0.2-0.9-0.5c-0.2-0.3-0.3-0.8-0.3-1.4 s0.1-1.1,0.3-1.4c0.2-0.3,0.5-0.5,0.9-0.5s0.7,0.2,0.9,0.5S108.7,65.3,108.7,65.9z M106.7,65.9c0,0.5,0.1,0.9,0.2,1.1 s0.3,0.4,0.6,0.4c0.3,0,0.5-0.1,0.6-0.4s0.2-0.6,0.2-1.1s-0.1-0.9-0.2-1.1s-0.3-0.4-0.6-0.4c-0.3,0-0.5,0.1-0.6,0.4 C106.8,65,106.7,65.4,106.7,65.9z"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart1);
export default __webpack_public_path__ + "static/media/chart1.1235739432bb36de6b9ad0d760bb8b65.svg";
export { ForwardRef as ReactComponent };